








import { initialHelper } from '@getaccept/lib-shared/src/helpers';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  props: {
    initials: {
      type: String,
      default: '',
    },
    verifiedInitials: {
      type: String,
      default: '',
    },
    fullName: {
      type: String,
      default: '',
    },
    completed: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const text = computed(() => {
      if (props.verifiedInitials) {
        return props.verifiedInitials;
      }
      if (props.completed) {
        return props.initials;
      }
      if (props.disabled) {
        return initialHelper(props.fullName);
      }
      return t('initials-abbreviation');
    });

    const isRequired = computed(() => !props.disabled && !props.completed);

    const handleClick = () => {
      emit('click');
    };

    return {
      text,
      isRequired,
      handleClick,
    };
  },
});
